<template>
<div>
    <basicSearchUI  v-on:getData = handleData
                    :enableSearch = searchPortConfig.enableSearch 
                    :items = portHistoryList.viewNodes
                     
                    :tableFields = portHistoryFields 
                    :search = searchHistory 
                    :rowClick = rowDetail >
    </basicSearchUI>
    <b-modal ref="modal_error" centered hide-footer title="錯誤">
      <p class="my-4">請「重新整理頁面」 或 「稍後重新查詢」</p>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Close Me</b-btn>
    </b-modal>

    <b-modal ref="modal_shipDetail" size="lg" hide-footer title="詳細資料">
      
      <b-container>
        <b-row>
          <b-col>
              <b-input-group>
                  <b-btn class="m-1" @click="See(aisLink)">AIS</b-btn>
              </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>{{ modalDetail.content["進出港"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"船名："}}</b-col>
          <b-col>{{ modalDetail.content["船名"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"英文名："}}</b-col>
          <b-col>{{ modalDetail.content["英文名"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"總噸："}}</b-col>
          <b-col>{{ modalDetail.content["毛重"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"國籍:"}}</b-col>
          <b-col>{{ modalDetail.content["國籍"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"代理:"}}</b-col>
          <b-col>{{ modalDetail.content["代理"]}}</b-col>
        </b-row>

        
        <b-row>
          <b-col>{{"前一港："}}</b-col>
          <b-col>{{ modalDetail.content["前一港"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"次一港:"}}</b-col>
          <b-col>{{ modalDetail.content["次一港:"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"泊地碼頭:"}}</b-col>
          <b-col>{{ modalDetail.content["泊地碼頭"]}}</b-col>
        </b-row>

        

        

        <b-row>
          <b-col>{{"----"}}</b-col>
          <b-col>{{"----"}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"通過堤口時間:"}}</b-col>
          <b-col>{{ modalDetail.content["通過堤口時間"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"進出港時間"}}</b-col>
          <b-col>{{ modalDetail.content["進出港時間"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"進港靠妥時間："}}</b-col>
          <b-col>{{ modalDetail.content["進港靠妥"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"出港離碼時間:"}}</b-col>
          <b-col>{{ modalDetail.content["出港離碼"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"預定引水時間:"}}</b-col>
          <b-col>{{ modalDetail.content["預定引水時間"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"引水時間:"}}</b-col>
          <b-col>{{ modalDetail.content["引水時間"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"領港下船時間:"}}</b-col>
          <b-col>{{ modalDetail.content["領港下船時間"]}}</b-col>
        </b-row>

        <b-row>
          <b-col>{{"總長:"}}</b-col>
          <b-col>{{ modalDetail.content["總長"]}}</b-col>
        </b-row>
        
        <b-row>
          <b-col>{{"長度:"}}</b-col>
          <b-col>{{ modalDetail.content["長度"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"船舶呼號："}}</b-col>
          <b-col>{{ modalDetail.content["船舶呼號"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"序號："}}</b-col>
          <b-col>{{ modalDetail.content["序號"]}}</b-col>
        </b-row>
        
        <b-row>
          <b-col>{{"IMO："}}</b-col>
          <b-col>{{ modalDetail.content["IMO"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"船隻掛號:"}}</b-col>
          <b-col>{{ modalDetail.content["船隻掛號"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"船舶號數:"}}</b-col>
          <b-col>{{ modalDetail.content["船舶號數"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"簽證編號:"}}</b-col>
          <b-col>{{ modalDetail.content["簽證編號"]}}</b-col>
        </b-row>
         <b-row>
          <b-col>{{"船種類:"}}</b-col>
          <b-col>{{ modalDetail.content["船種類"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"航次:"}}</b-col>
          <b-col>{{ modalDetail.content["航次"]}}</b-col>
        </b-row>
        
        </b-row>

      </b-container>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModalShipDetail">X</b-btn>
    </b-modal>
</div>
</template>

<script>
import basicSearchUI from "./basicSearchUI.vue"
const tpeSearch = require('../lib/tpeSearch/tpeSearch');
const Moment = require('moment');

//https://github.com/rotaready/moment-range#node--npm
const MomentRange = require('moment-range');
const moment = MomentRange.extendMoment(Moment);

export default {
  name: "portHistory",
  components:{
    basicSearchUI
  },
  data () {
    return {
      portHistoryFields: [
        { key: '船名', sortable: true },
        { key: '港口', sortable: true },
        { key: '預計引水', sortable: true },
        { key: '實際進出', sortable: true }
      ],
      portHistoryList:{
        viewNodes:[],
        deatils:[]
      },
      searchPortConfig : {
        enableSearch: false,
        report : "HistoryPortShipList",
        arg : {
          selectPort: "KEL",
          visaNo: undefined,
          special01: "False",
          special02: "False",
          spArrvDtFrom: "2018/07/26 00:00",
          spArrvDtTo: "2018/07/27 00:00",
          inoutPort: "進港"
        }
      },
      modalDetail: { title: '', content: '' },
      aisLink:""
    }
  },
  computed: {
    
  
  },
  methods:{
    handleData: function(getData) {
      this.searchPortConfig.arg = getData
    },

    searchHistory: function(getData){
      console.log(getData)

      this.searchPortConfig.arg = getData
      this.portHistoryList.viewNodes = []
      var e = this
      var url = tpeSearch.tpeUrl.getUrlFromPort(this.searchPortConfig)

      
      tpeSearch.tpeUrl.getJsonListFromUrl(url,

        function(){
          e.searchPortConfig.enableSearch = true
        },
        function(result){
          console.log(result)

          //有抓取到資料
          if(result!=null && result.ships!=undefined){
              result.ships["資料"].forEach(function(ship){
                
                //檢驗時間是否與查詢條件相符
                var startMoment = moment(e.searchPortConfig.arg.spArrvDtFrom,"YYYY/MM/DD h:mm")
                var endMoment = moment(startMoment).add(1,'days')
                var range = moment().range(startMoment, endMoment)
                var expecMoment = moment(ship['預定引水時間'],"YYYYMMDDh:mm")
                
                if(ship['預定引水時間']!="" && range.contains(expecMoment)){
                  var expect = ship['預定引水時間'];
                  var act = ship['進出港時間'];
                  
                  if(expect != ""){
                    expect = moment(ship['預定引水時間'],"YYYYMMDDh:mm").format("MMDD").toString() + "\n" +
                    moment(ship['預定引水時間'],"YYYYMMDDh:mm").format("HH:mm").toString() 
                  }
                  if(act != ""){
                    act = moment(ship['進出港時間']).format("MMDD").toString() + "\n" +
                    moment(ship['進出港時間']).format("HH:mm").toString() 
                  }
                  var viewNode = {
                    '船名': ship['船名'],
                    '港口':ship['泊地碼頭'],
                    '預計引水': expect,
                    '實際進出': act,
                    detail:ship
                  }
                  
                  
                  if(ship["進出港"] == e.searchPortConfig.arg.inoutPort){
                    e.portHistoryList.viewNodes.push(viewNode)
                  }
                }else{
                  //console.log(ship)
                }

            })
          }else{
            e.$refs.modal_error.show()
          }
          
          e.searchPortConfig.enableSearch = false
        }
      )
    },
    showModal () {
      e.$refs.modal_error.show()
    },
    hideModal () {
      this.$refs.modal_error.hide()
    },

    rowDetail (item,index,event){  
      console.log(item.detail)
      var shipDeail = Object.assign({}, item.detail);
      
      shipDeail["預定引水時間"] = tpeSearch.dateFormat(shipDeail['預定引水時間'])
      shipDeail["引水時間"] = tpeSearch.dateFormat(shipDeail['引水時間'])
      shipDeail["領港下船時間"] = tpeSearch.dateFormat(shipDeail['領港下船時間'])
      shipDeail["進港靠妥"] = tpeSearch.dateFormat(shipDeail['進港靠妥'])

      this.modalDetail.content = shipDeail

      if(this.modalDetail.content["IMO"].trim()==""){
        if(this.modalDetail.content["英文名"]!=""){
          var shipname = this.modalDetail.content["英文名"]
          shipname = shipname.replace(".","")
          this.aisLink = 'https://www.vesselfinder.com/vessels?name='+shipname
        }
      }else{
        this.aisLink = 'https://www.vesselfinder.com/vessels?name='+this.modalDetail.content["IMO"]
      }
      
      
      this.$refs.modal_shipDetail.show()
    },
    
    hideModalShipDetail(){
      this.$refs.modal_shipDetail.hide()
    },

    See (e) {
        window.open(e)
    }
    
  }
}
</script>




// WEBPACK FOOTER //
// src/components/portHistory.vue